'use strict';
import { environment } from '@environments/environment';
var BookingStep = /** @class */ (function () {
    function BookingStep(departure, arrival, date, stopover) {
        this._cost = null;
        this._selecting = 'date';
        this.flight_selected = false;
        this.date_selected = false;
        this._departure = departure;
        this._arrival = arrival;
        if (date) {
            this._date = this.INDRA_toISOString(date);
        }
        else {
            this._date = null;
        }
        if (stopover) {
            this.stopover = stopover;
        }
    }
    Object.defineProperty(BookingStep.prototype, "departure", {
        get: function () {
            return this._departure;
        },
        set: function (newDeparture) {
            this._departure = newDeparture;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BookingStep.prototype, "arrival", {
        get: function () {
            return this._arrival;
        },
        set: function (newArrival) {
            this._arrival = newArrival;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BookingStep.prototype, "date", {
        get: function () {
            if (this._date) {
                return this._date instanceof Date ? this._date : new Date(this._date);
            }
            else {
                return null;
            }
        },
        set: function (value) {
            if (value instanceof Date) {
                var date = new Date(value);
                this._date = this.INDRA_toISOString(date);
            }
            else {
                this._date = null;
            }
        },
        enumerable: true,
        configurable: true
    });
    BookingStep.prototype.showDate = function () {
        if (this.date) {
            // return this._date.toLocaleDateString(environment.locale, {
            // 	month: 'long',
            // 	day: 'numeric'
            // });
            return this.date.toLocaleDateString(environment.locale, {
                weekday: 'short',
                day: 'numeric',
                month: 'short',
                year: 'numeric'
            });
        }
        else {
            return '--/--/----';
        }
    };
    Object.defineProperty(BookingStep.prototype, "time", {
        get: function () {
            if (this.flight_selected) {
                return this.date.toLocaleTimeString(environment.locale, {
                    hour: 'numeric',
                    minute: 'numeric'
                });
            }
            else {
                return '--:--';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BookingStep.prototype, "done", {
        get: function () {
            return !!this._date;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BookingStep.prototype, "codeArrival", {
        get: function () {
            return this._arrival ? this._arrival.code : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BookingStep.prototype, "codeDeparture", {
        get: function () {
            return this._departure ? this._departure.code : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BookingStep.prototype, "nameArrival", {
        get: function () {
            return this._arrival && this._arrival.location ? this._arrival.location.city : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BookingStep.prototype, "nameDeparture", {
        get: function () {
            return this._departure && this._departure.location ? this._departure.location.city : null;
        },
        enumerable: true,
        configurable: true
    });
    BookingStep.prototype.toString = function () {
        return ((this._departure ? this._departure.code + ' -> ' : 'Blank Departure -> ') +
            (this._arrival ? this._arrival.code : 'Blank Arrival') +
            ' on ' +
            this.date +
            ' at ' +
            this.time);
    };
    Object.defineProperty(BookingStep.prototype, "cost", {
        get: function () {
            return this._cost;
        },
        set: function (newCost) {
            if (newCost)
                this._cost = newCost;
        },
        enumerable: true,
        configurable: true
    });
    BookingStep.prototype.INDRA_toISOString = function (date) {
        var tzo = -date.getTimezoneOffset(), dif = tzo >= 0 ? '+' : '-', pad = function (num) {
            return (num < 10 ? '0' : '') + num;
        };
        return date.getFullYear() +
            '-' + pad(date.getMonth() + 1) +
            '-' + pad(date.getDate()) +
            'T' + pad(date.getHours()) +
            ':' + pad(date.getMinutes()) +
            ':' + pad(date.getSeconds()) +
            dif + pad(Math.floor(Math.abs(tzo) / 60)) +
            ':' + pad(Math.abs(tzo) % 60);
    };
    return BookingStep;
}());
export { BookingStep };
